import React, { useEffect, useState } from "react";
import { useStore } from 'react-redux';
import { useHistory } from "react-router-dom";
import DiaSemanaAgenda from "../../comps/DiaSemanaAgenda/DiaSemanaAgenda";
import LogosCampanha from "../../comps/LogosCampanha/LogosCampanha";
import MensagemVideoModal from "../../comps/weexModais/MensagemVideoModal";
import WeexModalAtividades from "../../comps/weexModais/WeexModalAtividades";
import AgendaService from "../../services/AgendaService";
import CampanhaService from "../../services/CampanhaService";
import FeedbackService from "../../services/FeedbackService";
import LoaderService from "../../services/LoaderService";
import MensagemVideoService from "../../services/MensagemVideoService";
import TemaService from '../../services/TemaService';

function Atividades() {
	const i18n = useStore().getState().i18n
	const [feedback, setFeedback] = useState(null);

	const campanhaService = new CampanhaService();
	const agendaService = new AgendaService();
	const mensagemVideoService = new MensagemVideoService();
	const history = useHistory();
	const [campanha] = useState(campanhaService.campanhaCorrente());
	const [diasSemana, setDiasSemana] = useState();
	const [agenda, setAgenda] = useState(false);
	const [mensagemDeVideo, setMensagemDeVideo] = useState([]);
	const [atividadePopup, setExibirAtividadePopup] = useState(null);
	const [openClose, setOpenClose] = useState(false);
	const [erro, setErro] = useState(null);

	const callbackFeedback = (erro, result) => {
		if (erro) {
			setFeedback(null);
		} else {
			setFeedback(result);
		}
	};

	useEffect(() => {
		let service = new TemaService(campanhaService.campanhaCorrente())
		service.aplicarTema('HOME')

		mensagemVideoService.obterMensagemDeVideo((erro, sucesso) => {
			if (erro) {
				setErro(i18n.message("atividades.erro.video.prefixo", "Erro ao obter mensagem de video da campanha: ") + erro);
				return;
			}
			if (sucesso) {
				setOpenClose(true);
				setMensagemDeVideo(sucesso);
			}
		});
		const feedbackService = new FeedbackService();
		if (feedbackService.feedbackHabilitado()) {
			feedbackService.feedbackRespondido(callbackFeedback);
		}

		

		agendaService.agendaCorrente((erro, agenda) => {
			if (agenda && !diasSemana) {
				setAgenda(agenda);
				campanhaService.contadorCampanha((erro, sucesso)=>{
					if(erro){
						setErro(i18n.message("atividades.erro.dias.habilitados", "Erro ao obter a lista de dias habilitados da campanha: ") + erro);
						history.push("/");
						return;
					}
					if(sucesso){
						let dias = agenda.schedule.map((dia) => {
		
							let diaEnabled;
							return	(
								<div key={dia.scheduleCode}>
								{
									campanhaService.obterCheckStartDaCampanha() === null || campanhaService.obterCheckStartDaCampanha() === undefined ?
									"" :
									(
										campanhaService.obterCheckStartDaCampanha().map((diaHab)=> {
											if(diaHab === dia.day){
												diaEnabled = true
											}
										})
									)
								}
									<DiaSemanaAgenda
										dia={dia}
										diaEnabled={diaEnabled}
										navegar={navegar}
										key={dia.scheduleCode}
										mensagemDeVideo={mensagemDeVideo}
										evento={campanha}
									></DiaSemanaAgenda>
								</div>
						)});
						setDiasSemana(dias);
						if(campanha.requiredInterests && !agenda.pickedInterests){
							history.push("/interests");
						}
					}
				})
			}
			if (erro) {
				history.push("/");
			}
		});
	}, [])

	function navegar(rota, codigoAgenda, codigoAtividade, imagem) {
		new LoaderService().load(imagem);
		history.push("/" + rota + "/" + codigoAgenda + "/" + codigoAtividade);
	}

	function navegarTrofeu() {
		history.push("/trophy");
	}

	function navegarMensagemDeVideo(codigoMensagemDeVideo) {
		history.push("/video-message/" + codigoMensagemDeVideo);
	}

	function handleMensagemDeVideo(){
		setOpenClose(!openClose)
	}

	function popup(atividade) {
		setExibirAtividadePopup(atividade);
	}

	function ocultarPopup() {
		setExibirAtividadePopup(null);
	}

	function possui(agenda, tipo) {
		if (agenda) {
			let dias = agenda.schedule;
			for (let i = 0; i < dias.length; i++) {
				let dia = dias[i];
				for (let x = 0; x < dia.activities.length; x++) {
					let atividade = dia.activities[x];
					if (atividade.type === tipo) {
						return true;
					}
				}
			}
		}
		return false;
	}

	let botaoFeedback = null;
	if (feedback && !feedback.answered) {
		botaoFeedback = (
			<div
				style={{
					textAlign: "center",
					marginTop: "2em",
					marginBottom: "4em",
					fontSize: "0.8em",
					willChange: "auto",
				}}
			>
				<a
					onClick={() => {
						history.push("/feedback");
					}}
					className="weex-button__feedback"
				>
					{i18n.message("feedback.acao", "Conte-nos sobre sua experiência")}
				</a>
			</div>
		);
	}

	let botaoPersonalizado = (
		<div
		style={{
			textAlign: "center",
			marginTop: "2em",
			marginBottom: "4em",
			fontSize: "0.8em",
			willChange: "auto",
		}}
	>
		<a
			href="https://petrobras.service-now.com/eor"
			target="_blank"
			style={{
				backgroundColor: "rgb(0,133,66)",
				textTransform: "uppercase",
				padding: "1em",
				paddingLeft: "1em",
				paddingRight: "1em",
				border: "none",
				borderRadius: "10px",
				color: "white" 
			}}
		>
			Declaração de saúde
		</a>
	</div>
	);

	return (
		<div>
			<MensagemVideoModal
				visivel={openClose}
				handleMensagemDeVideo={handleMensagemDeVideo}
				mensagemDeVideo={mensagemDeVideo}
				navegarMensagemDeVideo={navegarMensagemDeVideo}
				agenda={agenda}
			/>
			{atividadePopup != null ? (
				<WeexModalAtividades
					callback={ocultarPopup}
					atividade={atividadePopup}
				/>
			) : null}
			<LogosCampanha campanha={campanha} />
			{
				campanha.code.toLowerCase() === "revap" || campanha.code.toLowerCase() === "revapteste" ?
				(
					botaoPersonalizado
				) : ""
			}
			<div className="atividades-container atividades-container__info">
				{possui(agenda, "VIDEO") ? (<div className="card-atividades" onClick={() => popup("video")}>
					<img src="./videos.png" alt={i18n.message("dinamica.video.nome", "VÍDEOS")}></img>
					<div className="card-atividades__span foreground">{i18n.message("dinamica.video.nome", "VÍDEOS")}</div>
				</div>) : null}

				{possui(agenda, "FACT_OR_FAKE") ? (<div className="card-atividades" onClick={() => popup("fatofake")}>
					<img
						src="./fatooufake.png"
						alt={i18n.message("dinamica.fatofake.nome", "FATO OU FAKE")}
					></img>
					<div className="card-atividades__span foreground">{i18n.message("dinamica.fatofake.nome", "FATO OU FAKE")}</div>
				</div>) : null}

				

				{possui(agenda, "NEW_HABIT") ? (
					<div
						className="card-atividades"
						onClick={() => popup("novoshabitos")}
					>
						<img
							src="./novoshabitos.png"
							alt={i18n.message("dinamica.novoshabitos.nome", "NOVOS HÁBITOS")}
						></img>
						<div className="card-atividades__span foreground">{i18n.message("dinamica.novoshabitos.nome", "NOVOS HÁBITOS")}</div>
					</div>
				) : null}

				{possui(agenda, "GAME") ? (
					<div className="card-atividades" onClick={() => popup("game")}>
						<img src="./jogos.png" alt={i18n.message("dinamica.game.nome", "GAME")}></img>
						<div className="card-atividades__span foreground">{i18n.message("dinamica.game.nome", "GAME")}</div>
					</div>
				): null}


				{possui(agenda, "EXTRA") ? (
					<div className="card-atividades" onClick={() => popup("extra")}>
						<img src="./calendario_contorno.png" alt={i18n.message("dinamica.extra.nome", "EXTRA")}></img>
						<div className="card-atividades__span foreground">{i18n.message("dinamica.extra.nome", "EXTRA")}</div>
					</div>
				): null}

				<div className="card-atividades" onClick={() => navegarTrofeu()}>
					<img
						src="./saladetrofeu.png"
						alt="Botão navegação sala de troféus"
					></img>
				</div>
			</div>
			<div className="agenda-container">
				{diasSemana}
			</div>
			{botaoFeedback}
		</div>
	);
}

export default Atividades;
